import { createResource } from '@atlassian/react-resource-router';
import getData from './get-data/index.tsx';

export const csmCustomerContextTenantMigratedStatusResource = createResource<boolean>({
	type: 'CSM_CUSTOMER_CONTEXT_TENANT_MIGRATED_STATUS',
	getKey: () => 'csm-customer-context-tenant-migrated-status',
	getData: async () => getData(),
	maxAge: 1000 * 60 * 60 * 24, // 1 day
	isBrowserOnly: true,
});
